/* The Prime Men - tasteful scroll-reveal motion.
   Gentle fade-up as content enters the viewport, with light stagger.
   Honours reduced-motion. Hard safety net reveals everything after 2.8s
   so content can never get stuck hidden if the observer misses. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('tpm-in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -7% 0px', threshold: 0.06 });

  function reveal(el, d) {
    if (!el || el.classList.contains('tpm-reveal')) return;
    el.classList.add('tpm-reveal');
    if (d) el.style.setProperty('--tpm-d', d + 'ms');
    io.observe(el);
  }
  function each(sel) {
    document.querySelectorAll(sel).forEach(function (el) { reveal(el, 0); });
  }
  function stagger(containerSel, itemSel, step, cap) {
    document.querySelectorAll(containerSel).forEach(function (c) {
      c.querySelectorAll(itemSel).forEach(function (el, i) {
        reveal(el, Math.min(i, cap || 6) * step);
      });
    });
  }

  function run() {
    /* before / after */
    each('.tpmba-head, .tpmba-wrap, .tpmba-note');
    /* why prime men */
    each('.tw-head');
    /* reviews header */
    each('.tpr-head');
    stagger('.tw-grid', 'figure', 90, 4);
    /* trust bar */
    stagger('.tpm-trust-row', '.tpm-ti', 70, 5);
    /* prime crew band (cascade) */
    ['.pc-eyebrow', '.pc-title', '.pc-sub', '.pc-note'].forEach(function (s, i) {
      document.querySelectorAll(s).forEach(function (el) { reveal(el, i * 80); });
    });
    document.querySelectorAll('.pc-title').forEach(function (t) {
      var f = t.parentElement && t.parentElement.querySelector('form');
      if (f) reveal(f, 300);
    });

    /* Featured Products + Combos cards cascade (skip cards hidden in inactive tabs) */
    document.querySelectorAll('.card-product').forEach(function (el, i) {
      if (el.offsetParent === null) return;
      reveal(el, (i % 4) * 110);
    });

    /* safety net: never leave anything hidden */
    setTimeout(function () {
      document.querySelectorAll('.tpm-reveal:not(.tpm-in)').forEach(function (el) {
        el.classList.add('tpm-in');
      });
    }, 2800);
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();

/* Eager-load product-section images ~1.4 screens early so Featured Products /
   Combos don't pop in with spinners while scrolling. Runs regardless of
   reduced-motion (this is loading, not animation). */
(function () {
  if (!('IntersectionObserver' in window)) return;
  function boost() {
    var secs = document.querySelectorAll('[id*="product_tab_block"], [id*="product_block"]');
    if (!secs.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        e.target.querySelectorAll('img.lazyload, img[loading="lazy"]').forEach(function (img) {
          if (img.classList.contains('lazyload')) {
            /* JS lazy-loader (lazysizes) images, e.g. the tab banner */
            if (img.dataset.sizes && img.dataset.sizes !== 'auto') img.setAttribute('sizes', img.dataset.sizes);
            if (img.dataset.srcset) img.setAttribute('srcset', img.dataset.srcset);
            if (img.dataset.src) img.setAttribute('src', img.dataset.src);
            img.classList.add('lazyloaded');
            img.classList.remove('lazyload');
            var fig = img.closest('figure, .adaptive_height, .image');
            var sp = fig && fig.querySelector('.data-lazy-loading');
            if (sp) sp.style.display = 'none';
          } else {
            /* native loading="lazy" product-card images: fetch now */
            img.loading = 'eager';
          }
        });
      });
    }, { rootMargin: '1400px 0px' });
    secs.forEach(function (s) { io.observe(s); });
  }
  if (document.readyState !== 'loading') boost();
  else document.addEventListener('DOMContentLoaded', boost);
})();
